var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAnyActivities)?_c('button',{staticClass:"cz2__reset-button",on:{"click":function($event){$event.preventDefault();return _vm.$emit('reset')}}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('RESET_CUSTOMIZATIONS'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }